import jQuery from 'jquery';
let $ = jQuery;

import "./Widget/AddToBag.js";

// define EVENTs
import "./Widget/ApplePay.js";
import "./ProductOptionSelector.js";
import "./Widget/QuantitySelector.js";

/**
    * class HSN.BuySelector
    *
    * Encapsulates the client functionality the Buy Selector Partial.
    * @param {object} [config] A configuration object
    **/
HSN.BuySelector = function(config) {
    /**
        * new HSN.BuySelector(config)
        * - config (Object): A configuration object for the [[HSN.BuySelector]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the BuySelector should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the BuySelector.
        *   - windowLocation (Location): The location object of the browser window.
        **/

    var scope = this;

    this._application = config.application;
    this._container = $(config.container);
    this._windowLocation = config.windowLocation;
    this._imageContainer = $(config.imageContainer);
    this._favoriteLink = $(config.favoriteLink);
    this._addToBagCallback = config.addToBagCallback;
    this._addToBagRefreshWhenDone = config.addToBagRefreshWhenDone;
    this._isPreviewModal = config.isPreviewModal;
    this._variants = config.variants;
    this._variantInfo = config.variantInfo;

    this._productImage = null;
    this._preSelectedWebId = $('.pre_selected_webid', scope._container).val();
    this._isEditBagPreview = $('.is_edit_bag_preview', scope._container).val();

    var quantitySelector = $('.quantity-selector', scope._container);
    if (quantitySelector.length) {
        this._quantitySelector = new HSN.QuantitySelector({
            application: this._application,
            container: quantitySelector
        });

        quantitySelector.on('qtyChanged', () => {
            scope._application.Events.Trigger(HSN.Widget.ApplePay.EVENT.TOGGLE_APPLE_PAY, scope.canDoApplePay());
        });
    }

    // Keep display in sync with the variantInfo
    this._variantInfo.onChange(() => {
        this.ClearErrors();
    });

    scope._application.Events.On(HSN.ProductOptionSelector.EVENT.OPTION_STATUS_CHANGED, function(text, container) {
        // make sure the containers match, in case there are multiple buy selectors on page
        if (scope._container.find('.product-option-selector')[0] === container[0]) {
            if ((text === 'On Waitlist' || text === 'Extended Delivery') && !$('.product-delivery-message').hasClass('is-override')) {
                $('.product-delivery-message').toggle(false);
            }
            else {
                $('.product-delivery-message').toggle(true);
            }
            $('.product-modal-option-status', scope._container).last().text(text);
            scope._application.Events.Trigger(HSN.Widget.ApplePay.EVENT.TOGGLE_APPLE_PAY, scope.canDoApplePay());
        }
    });

    $('input.add-to-bag, input.express-buy, .apple-pay-button',
        scope._container).on('click keydown', function (e) {

            var $this = $(this);

            if (e.type === 'keydown') {
               if (e.key !== 'Enter') {
                    return;
                }

                if (!$this.is('input')) {
                    $this = $this.siblings('input');
                }
            }
            else if (e.type === 'click') {
                if ($this.is('span.add-to-bag-proxy') || $this.is('span.express-buy-proxy')) {
                    return;
                }
            }

            //esrb
            var rating = $this.data('rating');
            if (rating) {
                //check for cookie
                var isOver17 = false;
                var i, x, y, arRcookies = document.cookie.split(';');
                var arrCookiesLength = arRcookies.length;
                for (i = 0; i < arrCookiesLength; i++) {
                    x = arRcookies[i].substr(0, arRcookies[i].indexOf('='));
                    y = arRcookies[i].substr(arRcookies[i].indexOf('=') + 1);
                    x = x.replace(/^\s+|\s+$/g, '');
                    if (x === 'over17') {
                        isOver17 = true;
                    }
                }

                if (!isOver17) {
                    HSN.Instance().GetRatingModal().Show(rating, $this);
                    return false;
                }
            }

            // As Is
            var isAsIs = $this.data('isasis');
            if (isAsIs) {
                //check for cookie
                var consentToAsIs = false;
                var index, name, cookies = document.cookie.split(';');
                var cookiesLength = cookies.length;
                for (index = 0; index < cookiesLength; index++) {
                    name = cookies[index].substr(0, cookies[index].indexOf('='));
                    name = name.replace(/^\s+|\s+$/g, '');
                    if (name === 'consentToAsIs') {
                        consentToAsIs = true;
                    }
                }

                if (!consentToAsIs) {
                    HSN.Instance().GetAsIsModal().Show($this);
                    return false;
                }
            }

            // Alcohol
            var isAlcohol = $this.data('isalcohol');
            if (isAlcohol) {
                var itsFunHere = sessionStorage.getItem('alcohol-verification') ? true : false;
            
                if (!itsFunHere) {
                    HSN.Instance().GetAlcoholModal().Show($this);
                    return false;
                }
            }

            var productId = $this.data('object-id');
            var productWebmId = $this.data('object-webmid');

            var request = scope.GetRequestObject($this, productId);

            if (request.Errors !== null && request.Errors.length > 0) {
                return false;
            }

            if ($this.data('personalize')) {
                var form = document.createElement('form');
                var inputId = document.createElement('input');
                inputId.setAttribute('type', 'hidden');
                inputId.setAttribute('name', 'Id');
                inputId.setAttribute('value', request.WebId);
                form.appendChild(inputId);
                var warrWebPId = document.createElement('input');
                warrWebPId.setAttribute('type', 'hidden');
                warrWebPId.setAttribute('name', 'WarrantyWebPId');
                warrWebPId.setAttribute('value', request.WarrantyWebPId);
                form.appendChild(warrWebPId);
                var inputQty = document.createElement('input');
                inputQty.setAttribute('type', 'hidden');
                inputQty.setAttribute('name', 'Qty');
                inputQty.setAttribute('value', request.Quantity);
                form.appendChild(inputQty);
                var inputFlex = document.createElement('input');
                inputFlex.setAttribute('type', 'hidden');
                inputFlex.setAttribute('name', 'flexpay');
                inputFlex.setAttribute('value', request.FlexPay);
                form.appendChild(inputFlex);
                var inputExtaFlex = document.createElement('input');
                inputExtaFlex.setAttribute('type', 'hidden');
                inputExtaFlex.setAttribute('name', 'extraFlex');
                inputExtaFlex.setAttribute('value', request.ExtraFlex);
                form.appendChild(inputExtaFlex);
                var inputExtaFlexPromo = document.createElement('input');
                inputExtaFlexPromo.setAttribute('type', 'hidden');
                inputExtaFlexPromo.setAttribute('name', 'extraFlexPromo');
                inputExtaFlexPromo.setAttribute('value', request.ExtraFlexPromo);
                form.appendChild(inputExtaFlexPromo);
                var inputDeferred = document.createElement('input');
                inputDeferred.setAttribute('type', 'hidden');
                inputDeferred.setAttribute('name', 'deferredPromo');
                inputDeferred.setAttribute('value', request.DeferredFinancing);
                form.appendChild(inputDeferred);
                
                form.action = '/products/personalization/get';
                form.method = 'post';
                var body = document.getElementsByTagName('body')[0];
                body.appendChild(form);
                form.submit();
            }
            else {
                var commerceService = HSN.Instance()._getCommerceService();
                if ($this.data('update-bag')) {
                    HSN.SetWait();
                    commerceService.UpdateVariant({ bagIdentity: $this.data('bag-id'), bagItemId: $this.data('basket-id'), webId: request.WebId}, {
                        callback : function(data) {
                            if(!data.success) {
                                HSN.RemoveWait();
                                alert('There was a problem editing your bag item. Please try again later.');
                            }
                            else {
                                location.reload();
                            }
                        },
                        scope: $this.get(0)
                    });
                }
                else {
                    if ($this.is(".express-buy")) {
                        HSN.LoaderSetWait();
                    }                    
                    else {
                        HSN.SetWait();
                    }
                    
                    var addToBag = {
                        ProductId: productId,
                        WebId: request.WebId,
                        DeferredFinancing: request.DeferredFinancing,
                        ExtraFlexPromo: request.ExtraFlexPromo,
                        ExtraFlex: request.ExtraFlex,
                        ExtraFlexV2: request.ExtraFlexV2,
                        ExpressBuy: request.ExpressBuy,
                        IsApplePay: request.IsApplePay,
                        Quantity: request.Quantity,
                        FlexPay: request.FlexPay,
                        FlexPayV2: request.FlexPayV2,
                        ProgramId: request.ProgramId,
                        ProgramCode: request.ProgramCode,
                        Frequency: request.Frequency,
                        StartDate: request.StartDate,
                        WarrantyWebPId: request.WarrantyWebPId,
                        WarrantyName: request.WarrantyName,
                        WarrantyAmount: request.WarrantyAmount,
                        MatrixId: productWebmId
                    };
                    var addToBagWidget = new HSN.Widget.AddToBag();
                    addToBagWidget.init({
                        application: scope._application,
                        isInPreviewModal: scope._isPreviewModal,
                        doFinish: !request.IsApplePay,
                        refreshWhenDone: scope._addToBagRefreshWhenDone
                    });
                    addToBagWidget.AddToBag(addToBag, scope._addToBagCallback);

                    if(request.IsApplePay) {
                        HSN.DataLayer.helpers.metricEvent(null, 'RE:PDP', 'applepay');
                        HSN.Widget.ApplePay().setupApplePaySession(scope.getProductPrice());
                    }
                }
            }
            return false;
        });

    //Fit Guide Modal trigger
    this._container.on('click', '.fit-guide-link', function(e) {
        e.stopPropagation();
        e.preventDefault();

        var webpId = $('#webp_id', scope._container).val();
        var defaultPage = $(this).data('default-page');
        var ajaxData = { 'webpId' : webpId, 'defaultPage' : defaultPage };
        
        if (defaultPage === "sizeRec") { // open modal window for Edit Measurements...
            if (webpId !== undefined) {
                var fitGuideModal = scope._application.GetFitGuideModal();
                fitGuideModal.elementToFocusOnClose = $(this);
                fitGuideModal.Show('/fitguide/get-fit-guide', ajaxData);
            }
            HSN.DataLayer.helpers.realEstate(null, "ProductPage-_-SizeAdvice-_-Add-Measurements");
        }
        else { // navigate to Size & Fit section and open Size Chart tab...
            // ReSharper disable once UnexpectedValue
            var tabHeader = $('h2:contains(Size & Fit)');
            if (tabHeader.length != 0) {
                var tabContent = tabHeader.parents().eq(1).find('.info');

                tabHeader.next().removeClass('plus').addClass('minus');
                $('html, body').animate({
                    scrollTop: tabHeader.offset().top - 69
                }, 500);
                tabContent.show();
                $('[target=hsn-size-content]').click().focus();

                HSN.DataLayer.helpers.realEstate(null, "ProductPage-_-SizeAdvice-_-View-Size-Chart");
            }
        }
    });

    this._container.on('click', ".autoship-modal", function (e) {
        e.stopPropagation();
        e.preventDefault();

        var articleSlug = jQuery(this).data("articleSlug");
        var articleId = jQuery(this).data("articleId");
        var webpId = $('#webp_id', scope._container).val();

        if (isNaN(articleId))
            return; //continue

        if (!articleSlug)
            articleId = 'default-article-slug';


        HSN.Instance().GetArticleModal().Show('/article/' + articleSlug + '/' + articleId + "?webpid=" + webpId);
    });

    this._container.on('change', '.template-product-detail-quantity', function () {
        scope._application.Events.Trigger(HSN.Widget.ApplePay.EVENT.TOGGLE_APPLE_PAY, scope.canDoApplePay());
    });

    this._container.on('change', '#payment-options', function () {
        cmCreateManualLinkClickTag('/product-flexpay?cm_sp=ProductPage-_-Flexpay-_-Dropdown&cm_re=ProductPage-_-FlexPay-_-Dropdown', 'ProductDetail');
        scope._application.Events.Trigger(HSN.Widget.ApplePay.EVENT.TOGGLE_APPLE_PAY, scope.canDoApplePay());
    });

    this._container.on('click', '.add-hpp-button', function() {
        var storedWarrantySelection = $('#selected-warranty', scope._container);
        var currentSelection = $(this);

        //update selected warranty
        storedWarrantySelection.val(currentSelection.data('warrantyWebpid'));
        storedWarrantySelection.data('warrantyPrice', currentSelection.data('warrantyPrice'));
        storedWarrantySelection.data('warrantyName', currentSelection.data('warrantyName'));

        //update button status
        currentSelection.removeClass('add-hpp-button');
        currentSelection.addClass('remove-hpp-button');
        currentSelection.val('REMOVE');

        //hide other warranty options
        $('.add-hpp-button').parents('.warranty-row').hide();

        //send apple pay event
        scope._application.Events.Trigger(HSN.Widget.ApplePay.EVENT.TOGGLE_APPLE_PAY, scope.canDoApplePay());
    });

    this._container.on('click', '.remove-hpp-button', function () {
        var storedWarrantySelection = $('#selected-warranty', scope._container);
        var currentSelection = $(this);

        //clear selected warranty
        storedWarrantySelection.val('');
        storedWarrantySelection.removeData();

        //update button status
        currentSelection.removeClass('remove-hpp-button');
        currentSelection.addClass('add-hpp-button');
        currentSelection.val('ADD');

        //make all options visible
        $('.add-hpp-button').parents('.warranty-row').show();

        //send apple pay event
        scope._application.Events.Trigger(HSN.Widget.ApplePay.EVENT.TOGGLE_APPLE_PAY, scope.canDoApplePay());
    });

    //Validator for autoship frequency
    this._container.on('blur', '.frequency', function() {
        var txt = $('.frequency');
        var amt = txt.val();

        var freq = txt.data('frequency');
        if(freq === undefined) {
            freq = 30;
        }

        if(!scope._application.IsAutoshipFrequencyValid({frequency: amt})) {
            txt.val(freq);
        }
    });    

    scope.LoadFitGuide();

    this.HandleObjectIdResponse = function(objectIdResponse, singleRequest) {
        singleRequest.WebId = objectIdResponse.value;

        if(objectIdResponse.errorList) {
            $.each(objectIdResponse.errorList, function(index, error) {
                singleRequest.Errors.push(error);
            });
        }

        return singleRequest;
    };
    this.GetVariantId = function(productCardScope, objectId) {
        var hasMatrix = $('.product-option-selector .matrix-options', productCardScope).length;

        if(scope._variants === null && hasMatrix) {
            var hasMatrixErrorMessage = $('.product-option-selector .tabs-label:first label:not(".waitlist-explainer") .matrix-selection-error', productCardScope).length;
            if (!hasMatrixErrorMessage) {
                let labelTxt = $('.product-option-selector .tabs-label:first label:not(".waitlist-explainer")', productCardScope).html().toLowerCase();
                labelTxt = labelTxt.includes('select') ? labelTxt : 'select ' + labelTxt;
                $('.product-option-selector .tabs-label:first label:not(".waitlist-explainer")', productCardScope).append('<span class="matrix-selection-error">Please ' + labelTxt + ' first.</span>');
            }

            return { value : objectId, errorList : ['Please select option first'] };
        }

        if (scope._variants !== null && scope._variants.length > 0) {
            var allErrors = [];
            var inputLabels = $('label.required-selection', productCardScope);
            var arr = [];

            $.each(inputLabels, function() {
                var inputLabel = $(this);
                var checkedInput = $('input[name="' + $(this).data('selection-name') + '"][data-checked="true"]', productCardScope);
                if(checkedInput.length === 0) {
                    var labelText = inputLabel.text().toLowerCase();
                    if(labelText.length) {
                        allErrors.push('Please select a ' + labelText);
                        inputLabel.addClass('inline-error');
                    }
                }
                else if(checkedInput.length > 0 && !checkedInput.data('is-group')) {
                    arr.push(checkedInput.attr('data-value'));
                }
            });

            //Item Sold out
            var variant = scope._variantInfo.SelectedVariant;
            if (!variant) {
                allErrors.push('Selection Not Available');
            }
            if (variant && variant.Callout && variant.Callout.Name === 'SoldOut') {
                allErrors.push('Item Sold Out');
            }

            var allErrorsLength = allErrors.length;
            if(allErrorsLength > 0) {
                var $errors = $('<div class="errors-pd" tabindex="0"><ul></ul><div></div></div>');

                for(var i = 0; i < allErrorsLength; i++) {
                    if(allErrors[i] !== null) {
                        $errors.find('ul').append('<li>' + allErrors[i] + '</li>');
                    }
                }

                var button = $('.add-to-bag-proxy', productCardScope);
                var oldError = $('div.errors-pd', productCardScope);
                oldError.remove();
                button.after($errors);
                var errorLeft = button.position().left + ((button.outerWidth() - $errors.outerWidth()) / 2);
                $errors.css({
                    "top" : parseInt('-' + ($errors.height() + 6)),
                    "left" : errorLeft
                });

                $errors.focus();
                $('.product-modal-option-status', productCardScope).last().text('');

                return { value : objectId, errorList : allErrors };
            }

            $.each(scope._variants, function(k, v) {
                if($(arr).not(v.Codes).length === 0 && $(v.Codes).not(arr).length === 0) {
                    objectId = v.WebId;
                    return;
                }
            });
        }

        return { value : objectId };
    };
    this.GetDeferredPay = function(productCardScope) {
        return $('#payment-options option:selected', productCardScope).hasClass('vip-payment');
    }
    this.GetExtraFlex = function(productCardScope) {
        var extraFlex = null;
        if ($('#payment-options option:selected', productCardScope).data('extra-flex') !== undefined) {
            extraFlex = $('#payment-options option:selected', productCardScope).data('extra-flex');
        }

        return extraFlex;
    };
    this.GetExtraFlexV2 = function (productCardScope) {
        var extraFlex = null;
        if ($('#payment-options option:selected', productCardScope).data('extra-flex') !== undefined) {
            var optionSelected = parseInt($('#payment-options option:selected', productCardScope).val());
            var totalFlexAvailable = $('#payment-options option:not(.extra-flex-payment, .vip-payment, .option-group)').length;
            var numberOfExtraFlex = (optionSelected - totalFlexAvailable) < 0 ? 0 : optionSelected - totalFlexAvailable;

            extraFlex = numberOfExtraFlex;
        }

        return extraFlex;
    };
    this.GetExtraFlexPromo = function(productCardScope) {
        var extraFlexPromo = null;
        if ($('#payment-options', productCardScope).data('extra-flex-promo') !== null) {
            extraFlexPromo = $('#payment-options', productCardScope).data('extra-flex-promo');
        }

        var deferredPay = scope.GetDeferredPay(productCardScope);
        if (deferredPay) {
            extraFlexPromo = $('.vip-payment', productCardScope).data('deferred-promo');
        }

        return extraFlexPromo;
    };
    this.GetExpressBuy = function(buttonObj) {
        var expressBuy = 0;
        if(buttonObj.hasClass('express-buy') || buttonObj.hasClass('apple-pay-button')) {
            expressBuy = 1;
        }

        return expressBuy;
    };
    this.GetApplePay = function (buttonObj) {
        var isApplePay = false;
        if (buttonObj.hasClass('apple-pay-button')) {
            isApplePay = true;
        }
        return isApplePay;
    }
    this.GetSelectedQuantity = function(productCardScope) {
        return $('.template-product-detail-quantity, .quantity-selector .qs-quantity', productCardScope).eq(0).val();
    };
    this.GetFlexpay = function(productCardScope) {
        var flexpay = null;
        if ($('.flex-payment', productCardScope).length > 0) {
            if ($('#payment-options option:selected', productCardScope).hasClass('single-payment')) {
                flexpay = 1;
            }
            else if ($('#payment-options option:selected', productCardScope).hasClass('flex-payment')) {
                flexpay = $('#payment-options', productCardScope).val();
            }
        }

        return flexpay;
    };

    this.GetFlexpayV2 = function (productCardScope) {
        var flexpay = 1;
        if ($('.flex-payment', productCardScope).length > 0) {
            if ($('#payment-options option:selected', productCardScope).hasClass('single-payment')) {
                flexpay = 1;
            }
            else if ($('#payment-options option:selected', productCardScope).hasClass('flex-payment')) {
                var optionSelected = parseInt($('#payment-options option:selected', productCardScope).val());
                var totalFlexAvailable = $('#payment-options option:not(.extra-flex-payment, .vip-payment, .option-group)').length;
                var numberOfFlexPayments = optionSelected > totalFlexAvailable ? totalFlexAvailable : optionSelected;

                flexpay = numberOfFlexPayments;
            }
        }

        return flexpay;
    };

    this.GetStartDate = function(productCardScope, autoshipId) {
        var theDate = new Date($('.datepicker', productCardScope).val());

        //no idea why but the month is always coming back 1 less than it should.
        var startDate = theDate.getFullYear() + '-' + (theDate.getMonth() + 1) + '-' + theDate.getDate();

        if(autoshipId !== null && startDate === 'NaN-NaN-NaN') {
            theDate = new Date();
            startDate = theDate.getFullYear() + '-' + (theDate.getMonth() + 1) + '-' + theDate.getDate();
        }

        return startDate;
    };
    this.GetFrequency = function(productCardScope) {
        var frequency = parseInt($('#autoship-frequency-options option:selected', productCardScope).val());

        return frequency;
    };
    this.GetAutoshipId = function(productCardScope) {
        var autoshipId = null;
        if($('.autoship', productCardScope).length > 0) {
            autoshipId = $('.autoship', productCardScope).data('program-id');
        }

        return autoshipId;
    };
    this.GetAutoshipProgramType = function(productCardScope) {
        var autoshipPgmType = null;
        if($('.autoship', productCardScope).length > 0) {
            autoshipPgmType = $('.autoship', productCardScope).data('program-type');
        }

        return autoshipPgmType;
    };
    this.GetSizeRecommendationTracking = function(productCardScope) {
        //Size Recommendation tracking on basket add
        var recommendedSize = $('.edit-size-measurements #FitGuideRecommendationId', productCardScope).val();
        var sizeIsAvailable = $('.edit-size-measurements #IsAvailable', productCardScope).val();

        var sizeRecommendationTracking = '';
        if(recommendedSize !== undefined && sizeIsAvailable !== undefined) {
            sizeRecommendationTracking = '1|' + $.trim(recommendedSize) + ',2|' + $.trim(sizeIsAvailable);
        }

        return sizeRecommendationTracking;
    };

    this.GetWarrantyWebPId = function(productCardScope) {
        var warrantySelected = scope.getWarrantySelected(productCardScope);
        var warrantyDetails = scope.getWarrantyDetails(productCardScope);

        return warrantySelected ? warrantyDetails.val() : null;
    };
    this.GetWarrantyPrice = function(productCardScope) {
        var warrantySelected = scope.getWarrantySelected(productCardScope);
        var warrantyDetails = scope.getWarrantyDetails(productCardScope);

        return warrantySelected ? warrantyDetails.data('warrantyPrice') : null;
    };
    this.GetWarrantyName = function(productCardScope) {
        var warrantySelected = scope.getWarrantySelected(productCardScope);
        var warrantyDetails = scope.getWarrantyDetails(productCardScope);

        return warrantySelected ? warrantyDetails.data('warrantyName') : null;
    };
    this.getWarrantySelected = function (warrSelectedScope) {
        var selectedWarranty = $('#selected-warranty', warrSelectedScope);

        return selectedWarranty.length > 0 && typeof(selectedWarranty.val()) !== 'undefined' && selectedWarranty.val().length > 0;
    };
    this.getWarrantyDetails = function (warrDetailsScope) {
        return $('#selected-warranty', warrDetailsScope);
    };
    this.getProductPrice = function () {
        if($('span[itemprop="price"]', '.product-price').length > 0) {
            return $('span[itemprop="price"]', '.product-price').attr('content');
        }
        else {
            return '.01';
        }
    };

    this.canDoApplePay = function () {
        if(!HSN.Widget.ApplePay) {
            return false;
        }
        var isValidQuantity, isValidPaymentOption, isValidWarranty, isValidProductStatus;
        //get quantity value
        var quantity = scope.GetSelectedQuantity(scope._container);
        if (quantity > 1) {
            isValidQuantity = false;
        }
        else {
            isValidQuantity = true;
        }
        //get flexpay value
        var paymentSelect = $('#payment-options');
        var flexNumber = paymentSelect.val();
        if ((flexNumber > 1 || $('option:selected', paymentSelect).attr('class') === 'vip-payment')) {
            isValidPaymentOption = false;
        }
        else {
            isValidPaymentOption = true;
        }
        //get warranty value
        var selectedWarranty = $('#selected-warranty', scope._container);
        if(selectedWarranty.val() && selectedWarranty.val().length > 0) {
            isValidWarranty = false;
        }
        else {
            isValidWarranty = true;
        }
        //get extended del/waitlist value
        var text = $('.product-modal-option-status', scope._container).last().text();
        if ((text === 'On Waitlist' || text === 'Extended Delivery')) {
            isValidProductStatus = false;
        }
        else {
            isValidProductStatus = true;
        }

        return isValidQuantity && isValidPaymentOption && isValidWarranty && isValidProductStatus;
    };           
};


HSN.BuySelector.prototype = {
    LoadFitGuide: function() {
        var scope = this;

        var hasFitGuide = jQuery('#has_fit_guide', scope._container).val();
        if (!hasFitGuide) { //only try to retrieve fit guide widget if product has one
            return;
        }

        var webpId = jQuery('#webp_id', scope._container).val();
        if (!webpId) {
            return;
        }

        var isSoldOut = $('#is_sold_out', scope._container).val() ? true : false;

        $.ajax('/fitguide/get-fit-guide-widget', {
            dataType: 'html',
            data: { webpId: webpId, enableFitGuide: !isSoldOut },
            success: function (data) {
                if ($('.edit-size-measurements', scope._container).length > 0) {
                    $('.edit-size-measurements', scope._container).html(data);
                    scope._application.Events.Trigger(HSN.BuySelector.EVENT.FITGUIDE_READY);
                }
            },
            error: function () {
                alert('Unfortunately there was an error attempting to calculate your measurement, please try again.');
            }
        });
    },
    GetRequestObject: function (buttonScope, objectId) {
        var scope = this;

        var singleRequest = {
            Errors: new Array()
        };

        singleRequest.ObjectId = objectId;
        singleRequest = scope.HandleObjectIdResponse(scope.GetVariantId(scope._container, singleRequest.ObjectId), singleRequest);
        singleRequest.DeferredFinancing = scope.GetDeferredPay(scope._container);
        singleRequest.ExtraFlex = scope.GetExtraFlex(scope._container);
        singleRequest.ExtraFlexV2 = scope.GetExtraFlexV2(scope._container);
        singleRequest.ExtraFlexPromo = scope.GetExtraFlexPromo(scope._container);
        singleRequest.ExpressBuy = scope.GetExpressBuy(buttonScope);
        singleRequest.IsApplePay = scope.GetApplePay(buttonScope);
        singleRequest.Quantity = scope.GetSelectedQuantity(scope._container);
        singleRequest.FlexPay = scope.GetFlexpay(scope._container);
        singleRequest.FlexPayV2 = scope.GetFlexpayV2(scope._container);
        singleRequest.ProgramId = scope.GetAutoshipId(scope._container);
        singleRequest.ProgramCode = scope.GetAutoshipProgramType(scope._container);
        singleRequest.StartDate = scope.GetStartDate(scope._container, singleRequest.ProgramId);
        singleRequest.Frequency = scope.GetFrequency(scope._container);
        singleRequest.SizeRecommendationTracking = scope.GetSizeRecommendationTracking(scope._container);
        singleRequest.WarrantyWebPId = scope.GetWarrantyWebPId(scope._container);
        singleRequest.WarrantyName = scope.GetWarrantyName(scope._container);
        singleRequest.WarrantyAmount = scope.GetWarrantyPrice(scope._container);

        return singleRequest;
    },
    ClearErrors: function () {
        var scope = this;
        scope._allErrors = [];

        $('label[class*="inline-error"]').removeClass('inline-error');
        $('div[class*="errors"]').remove();
        $('input[class*="has-error"]').removeClass('has-error');
        $('input[class*="inline-error"], select[class*="inline-error"]').removeClass('inline-error');
    },
}
/**
* HSN.BuySelector.EVENT = Object
* *
* * An enumeration of events an [HSN.BuySelector]] can raise:
* * * - FITGUIDE_MEASUREMENT_SUCCESS: Fires when an fitguide finds valid size variant for measurements given
* **/
HSN.BuySelector.EVENT = {
    FITGUIDE_MEASUREMENT_SUCCESS : 'HSN.BuySelector:FITGUIDE_MEASUREMENT_SUCCESS',
    FITGUIDE_READY : 'HSN.BuySelector:FITGUIDE_READY'
};



// WEBPACK FOOTER //
// ./assets/js/HSN/BuySelector.js